module.exports = __webpack_public_path__ + "static/media/ugol.c80e3894.png";